// extracted by mini-css-extract-plugin
export default {"zoomModal":"S3-z","image":"T3-z","button":"U3-z","isOverlayShown":"V3-z"};